import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Slide, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import HtmlTooltip from "../frames/html_tooltip";
import { CancelTwoTone, VisibilityTwoTone } from "@mui/icons-material";
import { forwardRef, useState } from "react";
import InvoiceButtonDialog from "./cancel_invoice";
import Loading2 from "../frames/loading2";
import InvoicesPayment from "./payment_invoice";
import InvoicesView from "./view_invoice";
import { getUserAccess } from "../frames/common";
import { getInvoiceAiAnalysis } from "./invoice_halper";
import Markdown from "react-markdown";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function InvoiceList({ invoice }) {
    const [deleteInvoice, setDeleteInvoice] = useState(null);
    const [viewInvoice, setViewInvoice] = useState(null);
    const [invoicePayment, setInvoicePayment] = useState(null);
    const [finAccess, setFinAccess] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [analysisReport, setAnalysisReport] = useState(null);

    if (finAccess === null) {
        setFinAccess(false);
        getUserAccess("ACCOUNTS_FIN").then((res) => {
            setFinAccess(res);
        }).catch((err) => {
            console.error(err);
        });
    }

    if (invoice === null) return <Loading2 />;

    const handleDeleteClose = (e) => {
        setDeleteInvoice(null);
    }

    const handleInvoiceDelete = (item) => {
        setDeleteInvoice(item);
    }

    const handlePaymentClose = (e) => {
        setInvoicePayment(null);
    }

    const handlePaymentSuccess = (change) => {
        invoicePayment.payment = 0;
        for (let idx = 0; idx < invoice.length; idx++) {
            const element = invoice[idx];
            if (element.bill_no === invoicePayment.bill_no) {
                invoice[idx] = invoicePayment;
            }
        }
        setInvoicePayment(null);
    }

    const handleInvoicePayment = (item) => {
        if (item.payment === 0) return;
        setInvoicePayment(item);
    }

    const handleInvoiceViewClose = (e) => {
        setViewInvoice(null);
        setInvoicePayment(null);
        setFinAccess(null);
        setErrorMessage(null);
        setAnalysisReport(null);
    }

    const handleAiAnalysis = (e) => {
        setErrorMessage(null);
        setAnalysisReport(null)
        getInvoiceAiAnalysis(viewInvoice.bill_no).then((res) => {
            console.log(res);
            if (res.code === 200) {
                setAnalysisReport(res.body.message);
            } else if (res.code === 202) {
                setErrorMessage(res.body.message);
            } else {
                throw res;
            }
        }).catch((err) => {
            console.error(err);
            setErrorMessage(err.message);
        });
    }

    const handleInvoiceView = (item) => {
        setViewInvoice(item);
    }

    return (
        <>
            <InvoiceButtonDialog open={deleteInvoice !== null} onClose={handleDeleteClose} data={deleteInvoice} />
            <InvoicesPayment open={invoicePayment !== null} onClose={handlePaymentClose} data={invoicePayment} onSuccess={handlePaymentSuccess} />
            {viewInvoice === null ? "" :
                <Dialog open={viewInvoice !== null} onClose={handleInvoiceViewClose} TransitionComponent={Transition}>
                    <DialogTitle variant="h6" color="info">Invoice {viewInvoice.bill_no}</DialogTitle>
                    <DialogContent>
                        {analysisReport ? <Typography variant="body2" color="info" textAlign={"justify"}><Markdown>{analysisReport}</Markdown></Typography> : ""}
                        <InvoicesView inv_num={viewInvoice.bill_no} />
                    </DialogContent>
                    <Box sx={{ px: 3, display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {errorMessage ? <Typography variant="caption" color="error" textAlign={"center"}><Markdown>{errorMessage}</Markdown></Typography> : ""}
                    </Box>
                    <DialogActions sx={{ pb: 3, px: 3 }}>
                        <Button variant="outlined" onClick={handleAiAnalysis}>Analysis</Button>
                        <Button variant="outlined" onClick={handleInvoiceViewClose}>Close</Button>
                        <Button variant="outlined" component="a" href={"/invoices/view/" + viewInvoice.bill_no} target="_blank">Print</Button>
                    </DialogActions>
                </Dialog>
            }
            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 4, overflow: "scroll", border: "1px solid", borderColor: "divider", }} >
                <Table size="small" sx={{ tableLayout: "auto", "& .MuiTableCell-root": { py: 0.75, px: 1.5, whiteSpace: "nowrap", borderColor: "divider", fontSize: "0.82rem", }, }} >
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "background.th", "& .MuiTableCell-root": { py: 1, fontWeight: 700, letterSpacing: 0.4, fontSize: "0.74rem", color: "textSecondary", }, }} >
                            <TableCell width={105}>Date</TableCell>
                            <TableCell width={90} align="right">Bill Number</TableCell>
                            <TableCell>Client</TableCell>
                            <TableCell width={110} align="right">Taxable</TableCell>
                            <TableCell width={90} align="right">GST</TableCell>
                            <TableCell width={120} align="right">Amount</TableCell>
                            <TableCell width={55} align="center">View</TableCell>
                            <TableCell width={120} align="center">Payment</TableCell>
                            <TableCell width={55} align="center">Cancel</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {invoice.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={9}>
                                    <Typography align="center" color="textSecondary" sx={{ py: 5 }}>
                                        No invoices available.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            invoice.map((row) => (
                                <TableRow
                                    key={row.inv_id}
                                    hover
                                    sx={{
                                        cursor: "default",
                                        transition: ".15s",
                                        bgcolor: row.canceled ? "error.lighter" : row.payment === 0 ? "success.lighter" : row.payment > 0 ? "warning.lighter" : "inherit",
                                        "&:hover": { bgcolor: (theme) => row.canceled ? theme.palette.error.light + "22" : row.payment === 0 ? theme.palette.success.light + "22" : row.payment > 0 ? theme.palette.warning.light + "22" : theme.palette.action.hover, },
                                        "& .MuiTableCell-root": { py: 0.65, },
                                    }}
                                >
                                    <TableCell>
                                        <Typography variant="body2">{row.bill_date}</Typography>
                                    </TableCell>

                                    <TableCell align="right">
                                        <Typography fontWeight={700} variant="body2">{row.bill_no}</Typography>
                                    </TableCell>

                                    <TableCell>
                                        <HtmlTooltip title={<Box> <Typography variant="caption"> {row.name} </Typography> <br /> <Typography variant="body2" color="info.main" > {row.client_id} </Typography> </Box>}>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap> {row.name}</Typography>
                                                {row.gst_num && (<Chip size="small" variant="outlined" color="secondary" label={row.gst_num} sx={{ mt: 0.3, height: 20, fontSize: "0.68rem", }} />)}
                                            </Box>
                                        </HtmlTooltip>
                                    </TableCell>

                                    <TableCell align="right">
                                        ₹{row.taxable_amount.toFixed(2)}
                                    </TableCell>

                                    <TableCell align="right">
                                        ₹{(row.bill_amount - row.taxable_amount).toFixed(2)}
                                    </TableCell>

                                    <TableCell align="right">
                                        <Typography sx={{ fontWeight: 600 }} color="primary.main">
                                            ₹{row.bill_amount.toFixed(2)}
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center">
                                        <IconButton size="small" onClick={() => handleInvoiceView(row)} sx={{ border: "1px solid", borderColor: "divider", p: 0.6, }}>
                                            <VisibilityTwoTone color="info" sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </TableCell>

                                    <TableCell align="center">
                                        {row.canceled || !finAccess ? null : (
                                            <Chip
                                                clickable
                                                size="small"
                                                onClick={() => handleInvoicePayment(row)}
                                                label={row.payment === 0 ? "Paid" : "Raise Payment"}
                                                color={row.payment === 0 ? "success" : row.payment === row.bill_amount ? "warning" : "secondary"}
                                                sx={{ height: 24, fontWeight: 600, fontSize: "0.72rem", }}
                                            />
                                        )}
                                    </TableCell>

                                    <TableCell align="center">
                                        {row.canceled || row.payment === 0 || !finAccess ? null : (
                                            <HtmlTooltip
                                                title={
                                                    <Box>
                                                        <Typography variant="subtitle2" > Warning </Typography>
                                                        <Typography variant="body2"> Invoice cancellation is permanent and cannot be undone. </Typography>
                                                    </Box>
                                                }
                                            >
                                                <IconButton
                                                    size="small" onClick={() => handleInvoiceDelete(row)}
                                                    sx={{ border: "1px solid", borderColor: "warning.light", p: 0.6, }}
                                                >
                                                    <CancelTwoTone color="warning" sx={{ fontSize: 18, }} />
                                                </IconButton>
                                            </HtmlTooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}

export default InvoiceList;
